export const LOGIN = "LOGIN"
export const LOGOUT = "LOGOUT"
export const  AUTH = "AUTH";
export const DATA = "DATA";
